<script>
    import { tick } from 'svelte';
    import {
        CONSTANTS,
        MULTI_CATEGORIES,
        NEGOCIOS_CATEGORIES,
        LALIGA_CATEGORIES,
    } from '../utils/constant';
    import {
        getDetailsByOffer,
        getStaticVel,
        getIsIncludedStreaming,
    } from '../utils/utils';

    export let plan, category, checkedCombos, movilExtName;

    const { vel, nombreCode } = plan;

    const {
        CATEGORY_4PLAY,
        CATEGORY_TRIPLEPLAY,
        CATEGORY_TRIPLEPLAY_MOVIL,
        CATEGORY_RESIDENCIAL,
        CATEGORY_IZZI_NEGOCIOS4P,
        CATEGORY_IZZI_NEGOCIOS3P,
        CATEGORY_IZZI_NEGOCIOS3PM,
        CATEGORY_IZZI_NEGOCIOS,
        CATEGORY_MOVIL,
        CATEGORY_TV,
    } = CONSTANTS;

    $: isCollapsed = false;

    const staticVel = getStaticVel(category, vel);
    let detailsByOffer = getDetailsByOffer(category, nombreCode, movilExtName);

    $: includedStreaming = getIsIncludedStreaming(plan, checkedCombos);

    const hasDefaultDetails = MULTI_CATEGORIES.has(category);
    const hasTv = [
        CATEGORY_4PLAY,
        CATEGORY_TRIPLEPLAY,
        CATEGORY_IZZI_NEGOCIOS4P,
        CATEGORY_IZZI_NEGOCIOS3P,
    ].includes(category);

    if (
        movilExtName !== '' &&
        [
            CATEGORY_4PLAY,
            CATEGORY_TRIPLEPLAY_MOVIL,
            CATEGORY_IZZI_NEGOCIOS4P,
            CATEGORY_IZZI_NEGOCIOS3PM,
        ].includes(category)
    ) {
        const additionalDetails = getDetailsByOffer(
            CATEGORY_MOVIL,
            nombreCode,
            movilExtName
        ).details;

        detailsByOffer = {
            ...detailsByOffer,
            details: [...detailsByOffer.details, ...additionalDetails],
        };
    }

    const toggleCollapse = () => {
        isCollapsed = !isCollapsed;
        tick().then(() => MicroModalInit());
    };

    function getDetailsList() {
        const list = [];

        if (NEGOCIOS_CATEGORIES.has(category)) {
            list.push({
                class: 'bullet-yellow',
                text: '2 líneas telefónicas con llamadas ilimitadas a fijos y celulares',
            });
        }

        if (hasDefaultDetails) {
            if (staticVel != vel) {
                list.push({
                    class: 'bullet-orange',
                    text: `<span>${vel}</span> ${staticVel} megas ${
                        [
                            CATEGORY_TRIPLEPLAY,
                            CATEGORY_RESIDENCIAL,
                            CATEGORY_IZZI_NEGOCIOS3P,
                            CATEGORY_IZZI_NEGOCIOS,
                        ].includes(category)
                            ? 'durante 6 meses'
                            : ''
                    }`,
                });
            }

            if (MULTI_CATEGORIES.has(category)) {
                list.push({
                    class: 'bullet-orange',
                    text: 'Suscripción a Skeelo incluida',
                });
            }

            if (hasTv) {
                list.push({
                    class: '',
                    linkText: '200 canales',
                    isLink: true,
                    linkAttributes: {
                        href: '#/',
                        'data-custom-open': 'canales_izzitvhdplus',
                    },
                    text: ' de TV',
                });

                list.push({
                    class: '',
                    text: 'Hasta 3 extensiones de TV',
                });
            }

            if (LALIGA_CATEGORIES.has(category)) {
                list.push({
                    class: '',
                    text: 'Sky sports. Incluye LALIGA EA sports',
                });
            }

            list.push({ class: '', text: 'ViX Premium 12 meses' });

            if (includedStreaming.IS_NETFLIX_ADD_INCLUDED) {
                list.push({
                    class: '',
                    text: 'Netflix Estándar con Anuncios incluido',
                });
            }
            if (includedStreaming.IS_NETFLIX_ESTANDAR_INCLUDED) {
                list.push({ class: '', text: 'Netflix Estándar incluido' });
            }
            if (includedStreaming.IS_MAX_ADD_INCLUDED) {
                list.push({
                    class: '',
                    text: 'Max básico con anuncios 12 meses',
                });
            }
            if (includedStreaming.IS_MAX_INCLUDED) {
                list.push({ class: '', text: 'Max incluido' });
            }
            if (includedStreaming.IS_APPLE_TV_INCLUDED) {
                list.push({ class: '', text: 'Apple TV+ durante 12 meses' });
            }
        }

        if (detailsByOffer.details.length > 0) {
            detailsByOffer.details.forEach((detail) => {
                list.push({
                    class: !CATEGORY_TV.includes(detailsByOffer.category)
                        ? 'bullet-pink'
                        : '',
                    text: detail,
                });
            });
        }

        if (NEGOCIOS_CATEGORIES.has(category)) {
            list.push({
                class: 'bullet-black',
                text: 'lector de tarjetas <span class="strong">clip Plus 2</span>',
            });

            list.push({
                class: 'bullet-black',
                text: 'facturación electrónica ilimitada',
            });
        }

        return list;
    }
</script>

<div class="plan-card__details-container">
    <button
        class="plan-card__details-btn"
        on:click={toggleCollapse}
        aria-expanded={!isCollapsed}
    >
        <p>más detalles</p>
        <svg class="icon {!isCollapsed && 'is-rotated'}" aria-hidden="true">
            <use xlink:href="/assets/img/icons/symbol-defs.svg#icon-angle-left"
            ></use>
        </svg>
    </button>
    {#if !isCollapsed}
        <div class="plan-card__details">
            <ul>
                {#each getDetailsList() as detail}
                    <li class={detail.class}>
                        {#if detail.isLink}
                            <a
                                href={detail.linkAttributes.href}
                                data-custom-open={detail.linkAttributes[
                                    'data-custom-open'
                                ]}
                                on:click|preventDefault={() => {}}
                            >
                                {detail.linkText}
                            </a>
                            {detail.text}
                        {:else}
                            {@html detail.text}
                        {/if}
                    </li>
                {/each}
            </ul>
        </div>
    {/if}
</div>
